import React from "react";
import clsx from "clsx";
import { FlagIcon } from "@heroicons/react/24/outline";
import { FlagIcon as FlagIconFilled } from "@heroicons/react/24/solid";

export function FlagForReviewButton({
  isFlagged,
  onClick,
  className,
}: {
  isFlagged: boolean;
  onClick: (e: React.MouseEvent) => void | Promise<void>;
  className?: string;
}) {
  return (
    <div
      role="button"
      className={clsx("group flex items-center cursor-pointer select-none", className)}
      onClick={onClick}
    >
      {isFlagged ? (
        <FlagIconFilled className="w-[24px] h-[24px] text-primary-500" />
      ) : (
        <>
          <FlagIcon className="w-[24px] h-[24px] text-neutral-700 group-hover:hidden" />
          <FlagIconFilled className="w-[24px] h-[24px] text-primary-500 hidden group-hover:block" />
        </>
      )}
      <div
        className={clsx(
          "ml-[12px] text-[14px] font-medium",
          isFlagged ? "text-primary-500" : "text-neutral-700 group-hover:text-primary-500",
        )}
      >
        {isFlagged ? "Remove Flag" : "Flag for Review"}
      </div>
    </div>
  );
}
